export default "__VITE_ASSET__YdGiJ4rj__"